import { useTranslation } from "react-i18next";
import IFolderChildren from "../../models/folder/IFolderChildren";
import { Tooltip } from "@fluentui/react-components";

export default function Prerequisites(props: { children: IFolderChildren }) {
    const { t } = useTranslation();
    const { children } = props;

    return (
        <div>
            <p>{t("folders.delete.prerequisites.message")}</p>
            <ul>
                {
                    children.folders > 0 &&
                    <li>{t("folders.delete.prerequisites.folders", { number: children.folders })}</li>
                }
                {
                    children.passwords > 0 &&
                    <li>{t("folders.delete.prerequisites.sharedPasswords", { number: children.passwords })}</li>
                }
                {
                    children.personalPasswords.map(pw => (
                        <Tooltip key={pw.upn} content={pw.upn} relationship="label" positioning="above">
                            <li>{t("folders.delete.prerequisites.personalPasswords", { number: pw.count, user: pw.displayName })}</li>
                        </Tooltip>
                    ))
                }
            </ul>
        </div>
    );
};